import type { FondDePapier } from '../api/types';

/**
 * Les mots des papiers posés sur la carte (chantier post-it-et-listes, ticket 02) : le post-it,
 * son papier, sa croix et « Annuler ». La maquette : `.scratch/chantiers/carnet/maquettes/
 * projet-ouvert.html` (« + Post-it » en bas à droite de la carte).
 */
export const POST_IT = 'Post-it';
export const POSER_UN_POST_IT = 'Poser un post-it sur cette carte';
export const TITRE_DU_POST_IT = 'Titre';
export const ECRIRE_SUR_LE_POST_IT = 'Écris ici…';
export const CHANGER_DE_PAPIER = 'Changer de papier';
export const SUPPRIMER_LE_POST_IT = 'Supprimer ce post-it';
export const POST_IT_SUPPRIME = 'Post-it supprimé';
/** La liste libre (ticket 04) : une todo posée sur la carte, sans lien avec les bulles. */
export const LISTE = 'Liste';
export const POSER_UNE_LISTE = 'Poser une liste sur cette carte';
export const TITRE_DE_LA_LISTE = 'Titre de la liste';
export const SUPPRIMER_LA_LISTE = 'Supprimer cette liste';
export const LISTE_SUPPRIMEE = 'Liste supprimée';
/** En bas de la liste, comme la maquette (« + ajouter »), avec la majuscule des mots de l'écran. */
export const AJOUTER_UNE_LIGNE = 'Ajouter';
export const UNE_LIGNE_DE_LA_LISTE = 'Une ligne de la liste';
export const COCHER_LA_LIGNE = 'Cocher cette ligne';
export const DECOCHER_LA_LIGNE = 'Décocher cette ligne';
/** La poignée du coin bas droit d'un papier (ticket 03). */
export const AGRANDIR_LE_PAPIER = 'Tire pour l’agrandir ou le rétrécir';

/** Les quatre papiers, dans l'ordre du menu. */
export const MOTS_DES_FONDS: Record<FondDePapier, string> = {
  jaune: 'Jaune',
  vert: 'Vert',
  lignes: 'À lignes',
  carreaux: 'À carreaux',
};

/** Un papier qui n'a pas pu être posé ou changé : ce qu'on en dit, d'après le refus du serveur. */
export function papierPasEcrit(code: string): string {
  if (code === 'plafond_de_papiers') return 'Cette bulle porte déjà le nombre maximal de papiers';
  if (code === 'plafond_de_lignes') return 'Cette liste a déjà le nombre maximal de lignes';
  if (code === 'hors_ligne') return 'Hors ligne : rien n’est écrit, réessaie quand le réseau revient';
  return 'Le papier n’a pas pu être écrit, réessaie';
}

/** « + Bulle », à côté de « + Liste » et « + Post-it » : fait sortir la barre de frappe (maquette `projet-ouvert.html`). */
export const BULLE = 'Bulle';
export const AJOUTER_UNE_BULLE_ICI = 'Ajouter une bulle ici';
